import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#140a0c] text-[#dfd8da] mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="font-display text-2xl text-white">The Improvaneer Method</div>
          <p className="mt-3 text-sm max-w-md text-[#bf6163]">
            Using improvisation to greatly increase social, workplace, and lifetime opportunities for people of
            ALL abilities. Confidence, communication, and connection — one game at a time.
          </p>
        </div>
        <div>
          <h3 className="text-xs uppercase tracking-[0.22em] font-extrabold text-white mb-3">Explore</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About &amp; Impact</Link></li>
            <li><Link to="/classes" className="hover:text-white">Classes &amp; Sessions</Link></li>
            <li><Link to="/certified-directors" className="hover:text-white">Certified Directors</Link></li>
            <li><Link to="/team" className="hover:text-white">Our Team</Link></li>
            <li><Link to="/games" className="hover:text-white">Games Library</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-xs uppercase tracking-[0.22em] font-extrabold text-white mb-3">Get Started</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/registration" className="hover:text-white">Register for a Class</Link></li>
            <li><Link to="/shop" className="hover:text-white">Enroll in a Class</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            <li><Link to="/play" className="hover:text-white">Join a Live Room</Link></li>
            <li><Link to="/login" className="hover:text-white">Console Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#3c2225] py-5 text-center text-xs text-[#545454]">
        © {new Date().getFullYear()} The Improvaneer Method · WCAG 2.2 AA · Built for accessible play
      </div>
    </footer>
  );
}
